import { CrudStoreItem } from 'legacy/lut/classes/models/CrudStoreItem'

import {
  FY24FormKeys,
  ISustainabilityFormsFY24,
} from '../../components/widgets/public/sustainability/InitiativeDetails/getInitiativeFY24FormKey'

interface IFormKey {
  formId: number
  code: string
}

interface ISustainabilityForms {
  [CrudStoreItem.SustainabilityPlan]: IFormKey
  [CrudStoreItem.SustainabilityPlanItems]: IFormKey
  [CrudStoreItem.SustainabilityActivityLogs]: IFormKey
  [CrudStoreItem.SustainabilityAttachments]: IFormKey
  [CrudStoreItem.ExecutiveSponsorshipFormM01]: IFormKey
  [CrudStoreItem.SustainableProcurementM02]: IFormKey
  [CrudStoreItem.SustainabilityDealFormM07]: IFormKey
  [CrudStoreItem.PrintFleetAssessmentM09]: IFormKey
  [CrudStoreItem.CommunicationsReportingFormM05]: IFormKey
  [CrudStoreItem.CustomerAwarenessFormM11]: IFormKey
  [CrudStoreItem.MarketingCampaignFormM111]: IFormKey
  [CrudStoreItem.OfficeRecyclingFormM14]: IFormKey
  [CrudStoreItem.EnergyEfficiencyFormM16]: IFormKey
  [CrudStoreItem.EmployeeWellBeingFormM21]: IFormKey
  [CrudStoreItem.VolunteeringFormM22]: IFormKey
  [CrudStoreItem.CommunityEngagementFormM24]: IFormKey
  [CrudStoreItem.UserInitiativesForm]: IFormKey
  [CrudStoreItem.DEIStrategyFormM18]: IFormKey
  [CrudStoreItem.SustainabilityPlan23]: IFormKey
  [CrudStoreItem.SustainabilityPlan24]: IFormKey
  [CrudStoreItem.SustainabilityPlan25]: IFormKey
  [CrudStoreItem.SustainabilityPlanItems23]: IFormKey
  [CrudStoreItem.SustainabilityPlanItems25]: IFormKey
  [CrudStoreItem.CustomerCaseStudiesM10]: IFormKey
  [CrudStoreItem.CarbonFootprintActionM15]: IFormKey
  [CrudStoreItem.SustainabilityFormM13]: IFormKey
  [CrudStoreItem.SustainabilityAttachments24]: IFormKey
  [CrudStoreItem.ExecutiveSponsorshipFormM0124]: IFormKey
  [CrudStoreItem.CommunicationsReportingFormM0524]: IFormKey
  [CrudStoreItem.CustomerAwarenessFormM1124]: IFormKey
  [CrudStoreItem.OfficeRecyclingFormM1424]: IFormKey
  [CrudStoreItem.EnergyEfficiencyFormM1624]: IFormKey
  [CrudStoreItem.DEIStrategyFormM1824]: IFormKey
  [CrudStoreItem.EmployeeWellBeingFormM2124]: IFormKey
  [CrudStoreItem.VolunteeringFormM2224]: IFormKey
  [CrudStoreItem.CommunityEngagementFormM2424]: IFormKey
  [CrudStoreItem.CarbonFootprintActionM1524]: IFormKey
  [CrudStoreItem.CustomerCaseStudiesM1024]: IFormKey
  [CrudStoreItem.SustainabilityFormM1324]: IFormKey
  [CrudStoreItem.UserInitiativesForm24]: IFormKey
  [CrudStoreItem.SustainabilityDealFormM0724]: IFormKey
  [CrudStoreItem.SustainabilityPlanItems24]: IFormKey
}

type ConfigForms = ISustainabilityForms & ISustainabilityFormsFY24

const prodData: ConfigForms = {
  [CrudStoreItem.SustainabilityPlan]: {
    formId: 898,
    code: 'sustainability-plan-hp-report',
  },
  [CrudStoreItem.SustainabilityPlanItems]: {
    formId: 899,
    code: 'sustainability-initiatives',
  },
  [CrudStoreItem.SustainabilityAttachments]: {
    formId: 900,
    code: 'hp-amplify-sustainability-attachments-hp-report',
  },
  [CrudStoreItem.SustainabilityActivityLogs]: {
    formId: 901,
    code: 'sustainability-activity-logs',
  },
  [CrudStoreItem.ExecutiveSponsorshipFormM01]: {
    formId: 904,
    code: 'executive-sponsorship-form-m-01-hp-report',
  },
  [CrudStoreItem.SustainableProcurementM02]: {
    formId: 981,
    code: 'hp-amplify-catalyst-initiatives',
  },
  [CrudStoreItem.SustainabilityDealFormM07]: {
    formId: 906,
    code: 'sustainability-deal-form-m-07-hp-report',
  },
  [CrudStoreItem.PrintFleetAssessmentM09]: {
    formId: 1028,
    code: 'aiih-print-fleet-assessments-m-09-v',
  },
  [CrudStoreItem.CommunicationsReportingFormM05]: {
    formId: 905,
    code: 'communications-reporting-form-m-05-hp-report',
  },
  [CrudStoreItem.CustomerAwarenessFormM11]: {
    formId: 907,
    code: 'customer-awareness-form-m11-hp-report',
  },
  [CrudStoreItem.MarketingCampaignFormM111]: {
    formId: 1030,
    code: 'aiih-syndication-showcase-report-m-11-2-v',
  },
  [CrudStoreItem.OfficeRecyclingFormM14]: {
    formId: 908,
    code: 'office-recycling-form-m-14-hp-report',
  },
  [CrudStoreItem.EnergyEfficiencyFormM16]: {
    formId: 909,
    code: 'energy-efficiency-form-m-16-hp-report',
  },
  [CrudStoreItem.EmployeeWellBeingFormM21]: {
    formId: 911,
    code: 'employee-well-being-form-m-21-hp-report',
  },
  [CrudStoreItem.VolunteeringFormM22]: {
    formId: 912,
    code: 'volunteering-form-m-22-hp-report',
  },
  [CrudStoreItem.CommunityEngagementFormM24]: {
    formId: 913,
    code: 'community-engagement-form-m-24-hp-report',
  },
  [CrudStoreItem.UserInitiativesForm]: {
    formId: 903,
    code: 'user-initiatives-form-hp-report',
  },
  [CrudStoreItem.DEIStrategyFormM18]: {
    formId: 910,
    code: 'dei-strategy-form-m18-hp-report',
  },
  [CrudStoreItem.SustainabilityPlan23]: {
    formId: 1246,
    code: 'sustainability-plan-hp-report-fy23',
  },
  [CrudStoreItem.SustainabilityPlan24]: {
    formId: 1436,
    code: 'sustainability-plan-hp-report-fy24',
  },
  [CrudStoreItem.SustainabilityPlan25]: {
    formId: 1860,
    code: 'sustainability-plan-hp-report-fy25',
  },
  [CrudStoreItem.SustainabilityPlanItems23]: {
    formId: 1247,
    code: 'sustainability-initiatives-fy23',
  },
  [CrudStoreItem.SustainabilityPlanItems25]: {
    formId: 1861,
    code: 'sustainability-initiatives-fy25',
  },
  [CrudStoreItem.CustomerCaseStudiesM10]: {
    formId: 1219,
    code: 'customer-case-studies-form-m-10-hp-report',
  },
  [CrudStoreItem.SustainabilityFormM13]: {
    formId: 1403,
    code: 'planet-partners-supplies-recycling-m-13-hp',
  },
  [CrudStoreItem.CarbonFootprintActionM15]: {
    formId: 1208,
    code: 'carbon-footprint-action-plan-m-15-report',
  },
  ...FY24FormKeys,
}

export const GetSustainabilityFormKey = (key: string) => {
  return prodData[key]
}
